/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { createAction, props } from '@ngrx/store';
import { ToolbeltActionsNames } from './toolbelt-actions-names';
import { SystemInfo } from '../../../../data-access/src/lib/domain/system-info';
import { TabDescription } from 'libs/sysque/toolbelt/data-access/src/lib/domain/tab-description';
import { HangerSpecification } from 'libs/sysque/toolbelt/data-access/src';
import { SysquePopupConfig, ToolGroup } from '@hcworkspace/sysque/toolbelt/feature';
import { Item } from 'libs/sysque/toolbelt/data-access/src/lib/domain/item';
import { PanelDetails } from '../models/panel-detail';
import { BooleanObject } from '../models/boolean-object';
import { ElectricalSettingsReturnCodes } from '../models/electrical-settings-return-codes';
import { ProjectRecords } from '../models/project-records';

export const InitializeToolbeltAccordionGroups = createAction(ToolbeltActionsNames.InitializeToolbeltAccordionGroups());

export const InitializeToolbeltAccordionGroupsSuccess = createAction(
  ToolbeltActionsNames.InitializeToolbeltAccordionGroupsSuccess(),
  props<{ accordionGroups: ToolGroup[] }>()
);

export const InitializeSystemInfo = createAction(ToolbeltActionsNames.InitializeSystemInfo());

export const InitializeSystemInfoSuccess = createAction(
  ToolbeltActionsNames.InitializeSystemInfoSuccess(),
  props<{ systemInfo: SystemInfo[] }>()
);

export const GetProjectsList = createAction(ToolbeltActionsNames.GetProjectsList());

export const GetProjectsListSuccess = createAction(
  ToolbeltActionsNames.GetProjectsListSuccess(),
  props<{ projectList: ProjectRecords[] }>()
);

export const updateCategories = createAction(
  '[ToolBelt] Update categories',
  props<{ categoryList: TabDescription[] }>()
);

export const UpdateSystemInfo = createAction(ToolbeltActionsNames.UpdateSystemInfo());

export const UpdateSystemInfoSuccess = createAction(
  ToolbeltActionsNames.UpdateSystemInfoSuccess(),
  props<{ systemInfo: SystemInfo[] }>()
);

export const InitializeHangerSpecifications = createAction(ToolbeltActionsNames.InitializeSystemInfo());

export const InitializeHangerSpecificationsSuccess = createAction(
  ToolbeltActionsNames.InitializeHangerSpecificationsSuccess(),
  props<{ hangerSpecifications: HangerSpecification[] }>()
);

export const ShowSysquePopupAction = createAction(
  ToolbeltActionsNames.ShowSysquePopupAction(),
  props<{ sysquePopupConfig: SysquePopupConfig }>()
);

export const setAddFittingModeAction = createAction(
  ToolbeltActionsNames.setAddFittingModeAction(),
  props<{ mode: boolean }>()
);

export const setManageModeAction = createAction(ToolbeltActionsNames.setManageModeAction(), props<{ mode: boolean }>());

export const sendPopupRoutingAction = createAction(
  ToolbeltActionsNames.sendPopupRoutingAction(),
  props<{ route: string; width: number; height: number }>()
);

export const sendPopupRoutingActionSuccess = createAction(
  ToolbeltActionsNames.sendPopupRoutingActionSuccess(),
  props<{ response: string }>()
);

export const onAddProjectClickAction = createAction(
  ToolbeltActionsNames.onAddProjectClickAction(),
  props<{ width: number; height: number }>()
);

export const onAddProjectClickActionSuccess = createAction( ToolbeltActionsNames.onAddProjectClickActionSuccess() );

export const sendClosePopupAction = createAction(ToolbeltActionsNames.sendClosePopupAction());

export const sendClosePopupActionSuccess = createAction(
  ToolbeltActionsNames.sendClosePopupActionSuccess(),
  props<{ response: string }>()
);

export const UpdateRootPath = createAction(ToolbeltActionsNames.UpdateRootPath());

export const UpdateRootPathSuccess = createAction(
  ToolbeltActionsNames.UpdateRootPathSuccess(),
  props<{ updatedRootPath: string }>()
);

export const getFittingsListActionSuccess = createAction(
  ToolbeltActionsNames.getFittingsListActionSuccess(),
  props<{ fittingList: Item[] }>()
);

export const InitializeRootPath = createAction(ToolbeltActionsNames.InitializeRootPath());

export const InitializeRootPathSuccess = createAction(
  ToolbeltActionsNames.InitializeRootPathSuccess(),
  props<{ filePath: string }>()
);

export const initializeProjectList = createAction(
  ToolbeltActionsNames.InitializeProjectList()
);

export const initializeProjectListSuccess = createAction(
  ToolbeltActionsNames.InitializeProjectListSuccess(),
  props<{ projectList: string[] }>()
);

export const getProcessFittingStatus = createAction(ToolbeltActionsNames.getProcessFittingStatus());

export const getProcessFittingStatusSuccess = createAction(
  ToolbeltActionsNames.getProcessFittingStatusSuccess(),
  props<{ status: BooleanObject }>()
);

export const InitializePanelListSuccess = createAction(
  ToolbeltActionsNames.InitializePanelListSuccess(),
  props<{ dockPanelList: PanelDetails[] }>()
);

export const updateIsHangerNeeded = createAction(
  ToolbeltActionsNames.updateIsHanger(),
  props<{ systemName: string; isChecked: boolean }>()
);

export const updateIsHangerNeededSuccess = createAction(
  ToolbeltActionsNames.updateIsHangerSuccess(),
  props<{ isHangerUpdated: BooleanObject }>()
);

export const updateIsClearance = createAction(
  ToolbeltActionsNames.updateIsClearance(),
  props<{ systemName: string; isChecked: boolean }>()
);

export const updateIsClearanceSuccess = createAction(
  ToolbeltActionsNames.updateIsClearanceSuccess(),
  props<{ isClearanceUpdated: BooleanObject }>()
);

export const CheckInvalidShortcuts = createAction(
  ToolbeltActionsNames.checkInvalidShortcuts()
);

export const CheckInvalidShortcutsSuccess = createAction(
  ToolbeltActionsNames.checkInvalidShortcutsSuccess(),
  props<{ invalidShortcut: ElectricalSettingsReturnCodes }>()
);

export const GetConfigurationLocation = createAction(ToolbeltActionsNames.getConfigurationLocation());

export const GetConfigurationLocationSuccess = createAction(
  ToolbeltActionsNames.getConfigurationLocationSuccess(),
  props<{ configurationLocation: string }>()
);